<template>
  <div>
    <div class="footer-bottom-top bg-white">
      <div class="container">
        <div class="row footer-contents">
          <div class="col-md">
            <h5 class="mb-2">Join Us On</h5>
            <div class="d-flex align-items-center mt-2 socials">
              <a
                href="https://facebook.com/usesellersmart"
                target="_blank"
                rel="noreferrer nofollow"
                ><i
                  class="fa-brands fa-facebook-f text-dark"
                  aria-hidden="true"
                ></i>
              </a>
              <a
                href="https://twitter.com/usesellersmart"
                target="_blank"
                rel="noreferrer nofollow"
                ><i
                  class="fa-brands fa-x-twitter text-dark"
                  aria-hidden="true"
                ></i>
              </a>
              <a
                href="https://instagram.com/usesellersmart"
                target="_blank"
                rel="noreferrer nofollow"
                ><i
                  class="fa-brands fa-instagram text-dark"
                  aria-hidden="true"
                ></i>
              </a>
            </div>
          </div>
          <div class="col-md align-self-center">
            <div class="d-flex" style="gap: 10px">
              <i class="fa-solid fa-location-dot"></i>
              <p>Cyberville Horizon Estate, Lekki, Lagos</p>
            </div>
          </div>
          <div class="col-md align-self-center">
            <a
              href="mailto:contact@sellersmart.ng"
              style="text-decoration: none; color: #000"
            >
              <div class="d-flex" style="gap: 10px">
                <i class="fa-solid fa-envelope"></i>
                <p>contact@sellersmart.ng</p>
              </div>
            </a>
          </div>
          <div class="col-md payment-methods">
            <h5 class="mb-4">Payment Methods</h5>
            <div class="d-flex align-items-center" style="gap: 20px">
              <img
                src="@/assets/icons/verve.svg"
                loading="lazy"
                class="img-fluid"
                style="width: 25%"
                alt=""
              />
              <img
                src="@/assets/icons/visa.svg"
                loading="lazy"
                class="img-fluid"
                style="width: 20%; margin-top: 0.5rem"
                alt=""
              />
              <img
                src="@/assets/icons/mastercard.svg"
                loading="lazy"
                class="img-fluid"
                style="width: 18%; margin-top: 0.7rem"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="footer-bottom-bottom bg-primary py-4">
      <div class="container">
        <small class="text-white">
          &copy; {{ year }} All Rights Reserved by
          <router-link to="/" class="text-white">sellersmart.ng</router-link>
        </small>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    year() {
      return new Date().getFullYear();
    },
  },
};
</script>
